module.exports = __webpack_public_path__ + "img/s3-3.732393b2.webp";